import { useState } from 'react'

// ─── RoutineEntry — collapsible accordion item ────────────────────────────────
function RoutineEntry({ entry, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className='up-routine-entry'>
      {/* ── Header — always visible, click to toggle ── */}
      <div
        className='up-routine-entry-header'
        onClick={() => setOpen((v) => !v)}
      >
        <div className='up-routine-entry-header-left'>
          <div className='up-routine-entry-title'>{entry.title}</div>
          <div className='up-routine-entry-date'>{entry.date}</div>
        </div>

        <div className='up-routine-entry-meta'>
          <span className='up-routine-entry-count'>
            {entry.steps.length} steps
          </span>
          <span className={`up-routine-entry-chevron${open ? ' open' : ''}`}>
            ▼
          </span>
        </div>
      </div>

      {/* ── Body — only rendered when open ── */}
      {open && (
        <div className='up-routine-entry-body'>
          {entry.steps.map((r, i) => (
            <div
              className='up-routine-item'
              key={r.step}
              style={{ animationDelay: `${i * 0.06}s` }}
            >
              <div className='up-step-num'>{r.step}</div>
              <div className='up-step-body'>
                <div className='up-step-title'>{r.title}</div>
                <div className='up-step-detail'>{r.detail}</div>
                <div className='up-step-freq'>⏱ {r.freq}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default RoutineEntry
